;(function () {
  angular.module('contrast.auth').controller('LogoutCtrl', LogoutCtrl)

  function LogoutCtrl($scope, logoutService) {
    'ngInject'

    angular.extend($scope, {
      logout: logoutService.logout
    })
  }
})()
